import { render, staticRenderFns } from "./InAppPurchaseOffersView.vue?vue&type=template&id=bdee4656&scoped=true&"
import script from "./InAppPurchaseOffersView.vue?vue&type=script&lang=js&"
export * from "./InAppPurchaseOffersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdee4656",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VCheckbox,VForm})
